import * as React from 'react';
import cx from 'classnames';
import get from 'lodash/get';
import ChatClient from 'fk-cp-chat';
import PropTypes from 'prop-types';
import { Actions, handleChatActions } from 'utils/chatActionHandlers';
import styles from './OptionedMessage.css';
export default class OptionedMessage extends React.Component {
    constructor(props) {
        super(props);
        this.handleOptionClick = response => () => {
            const { disable } = this.props;
            if (disable) {
                return;
            }
            const data = {
                type: 'optionedResponse',
                response,
                responseToId: this.props.messageId
            };
            const sendMsgAction = response.data.actions.find(({ type }) => type === Actions.SEND_MESSAGE);
            const params = sendMsgAction.params || null;
            if (params && params.chatMessage) {
                const chatMessage = JSON.parse(params.chatMessage);
                chatMessage.responseToId = this.props.messageId;
                params.chatMessage = JSON.stringify(chatMessage);
            }
            this.chatClient.sendWidgetAction(this.props.selectedChat, data);
            this.props.messageSendCallback();
            handleChatActions(response.data.actions, this.context.router);
        };
        this.chatClient = ChatClient.getInstance();
    }
    render() {
        const headerText = get(this.props, 'data.data.headerText');
        const responses = get(this.props, 'data.responses');
        const { disable } = this.props;
        return (<div className={styles['optioned-message']}>
				<div className={styles['header-text']}>{headerText}</div>
				<div className={styles['options']}>
					{responses.map((response, index) => {
            const buttonText = get(response, 'data.optionText');
            const buttonSubText = get(response, 'data.subText');
            return (<div key={index} onClick={this.handleOptionClick(response)} className={cx(styles['btn'], styles['option-btn'], {
                [styles['disabled']]: disable
            })}>
								<div>{buttonText}</div>
								{buttonSubText && <div className={styles['option-btn-subtext']}>{buttonSubText}</div>}
							</div>);
        })}
				</div>
			</div>);
    }
}
OptionedMessage.contextTypes = {
    router: PropTypes.object
};
